import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { BdcBranch } from "../../../types/bdc.type";
import { ALL_BRANCHES, branchCodeOf } from "./branches";

/**
 * ทุกสาขา / one pill per BDC branch. Rendered only for a viewer who sees more than one branch
 * (head office, MASTER, หัวหน้า BDC); เจ้าหน้าที่ BDC sees its own branch only, so no selector.
 */
export default function BranchSelector({
  branches,
  value,
  onChange,
  disabled,
  allowAll = true,
}: Readonly<{
  branches: BdcBranch[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** false on screens that work one branch at a time (ขาด-เกิน): no ทุกสาขา pill. */
  allowAll?: boolean;
}>) {
  if (branches.length <= 1) return null;
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      disabled={disabled}
      aria-label="สาขา BDC"
      onChange={(_e, next: string | null) => {
        if (next) onChange(next);
      }}
      sx={{ "& .MuiToggleButton-root": { px: 1.5, py: 0.5, textTransform: "none" } }}
    >
      {allowAll && <ToggleButton value={ALL_BRANCHES}>ทุกสาขา</ToggleButton>}
      {branches.map((branch) => (
        <ToggleButton key={branch.company_id} value={branch.company_id} title={branch.branch_name ?? undefined}>
          {branchCodeOf(branch)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
